/* PaperDigits CRO helpers for butikalkmaar.
   Reputon review widgets inject build-hashed class names (goXXXXXXX), so CSS
   alone cannot target the review cards reliably across app updates. The CSS
   rules in pd-cro.css cover the currently known hashes (no flash of rounded
   corners); this observer is the future-proof safety net: it flattens any
   24px-rounded element inside a Reputon widget, whatever its class name.
   24px is unique to the review cards - avatars and nav arrows use 50%. */
(function () {
  'use strict';
  /* getComputedStyle forces a style recalculation and the carousel rewrites
     its slides every few seconds, so every element is inspected only once and
     mutation bursts are handled once per frame */
  var seen = new WeakSet();
  function flatten(scope) {
    scope.querySelectorAll('div').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      if (getComputedStyle(el).borderRadius === '24px') {
        el.style.borderRadius = '0';
      }
    });
  }
  function init() {
    document.querySelectorAll('.reputon-google-reviews-widget').forEach(function (w) {
      var queued = false;
      flatten(w);
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          flatten(w);
        });
      }).observe(w, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Sticky add-to-cart bar: show the currently selected variant (size) on the
   left and keep the price on the right, so the shopper who scrolled down can
   confirm the choice without going back up. Styled/positioned in pd-cro.css. */
(function () {
  'use strict';
  function selectedVariantText() {
    /* one value per option fieldset; the sticky bar hosts its own hidden
       picker and stray non-variant radios report value "on" - skip both */
    var parts = [];
    var seen = [];
    var sets = document.querySelectorAll('.product__info-container fieldset.product-form__input');
    [].forEach.call(sets, function (fs) {
      if (fs.closest('.product-sticky-cart')) return;
      /* hidden duplicate pickers can lag behind the visible one - skip them */
      if (fs.offsetParent === null) return;
      var i = fs.querySelector('input[type="radio"]:checked');
      /* the same option can be rendered by more than one fieldset (theme keeps
         them in sync) - deduplicate by value */
      if (i && i.value && i.value !== 'on' && seen.indexOf(i.value) === -1) {
        seen.push(i.value);
        /* pill fieldsets carry the downcased option name as a class; only the
           size value gets the label the bar is meant to confirm */
        if (fs.classList.contains('size') || fs.classList.contains('maat')) {
          parts.push('Maat: ' + i.value);
        } else {
          parts.push(i.value);
        }
      }
    });
    if (parts.length) return parts.join(' / ');
    var sel = document.querySelector('.product__info-container select[name="id"]');
    if (sel && sel.selectedIndex > -1) {
      return 'Maat: ' + sel.options[sel.selectedIndex].textContent.trim();
    }
    return '';
  }
  function update() {
    var content = document.querySelector('.product-sticky-cart .sticky-cart__content');
    if (!content) return;
    var span = content.querySelector('.pd-sticky-variant');
    if (!span) {
      span = document.createElement('span');
      span.className = 'pd-sticky-variant';
      /* between the product thumbnail and the price block */
      var heading = content.querySelector('.sticky-cart__content-heading');
      content.insertBefore(span, heading || content.firstChild);
    }
    span.textContent = selectedVariantText();
  }
  document.addEventListener('change', function () { setTimeout(update, 50); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();

/* Product card image swipe (touch screens, collection grid). Markup comes from
   snippets/pd-card-swipe.liquid: an overlay with an empty first slide and up to
   three more slides whose images only carry data attributes. This gives those
   images real sources on the first touch (the next slide first, the rest once
   the swipe starts), keeps the dots in sync and pushes the card's own image
   aside while the track scrolls, so the gesture reads as one gallery. */
(function () {
  'use strict';
  if (!('closest' in Element.prototype) || !window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 989px)');
  function hydrate(swipe, all) {
    var imgs = swipe.querySelectorAll('img[data-srcset]');
    var sizes = swipe.getAttribute('data-sizes') || '';
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.sizes = sizes;
      img.srcset = img.getAttribute('data-srcset');
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-srcset');
      if (!all) return;
    }
  }
  function onTouch(e) {
    if (!mq.matches || !e.target || !e.target.closest) return;
    var swipe = e.target.closest('.pd-swipe');
    if (swipe) hydrate(swipe, false);
  }
  var pending = null;
  function onScroll(e) {
    var track = e.target;
    if (!track || !track.classList || !track.classList.contains('pd-swipe__track')) return;
    if (pending) return;
    pending = track;
    requestAnimationFrame(function () {
      var swipe = pending.parentNode;
      var x = pending.scrollLeft;
      pending = null;
      if (x > 0) hydrate(swipe, true);
      var picture = swipe.parentNode.querySelector('picture');
      if (picture) picture.style.transform = x > 0 ? 'translateX(' + (-x) + 'px)' : '';
      var index = Math.round(x / swipe.clientWidth);
      var dots = swipe.querySelectorAll('.pd-swipe__dot');
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === index);
    });
  }
  function reset() {
    var overlays = document.querySelectorAll('.pd-swipe');
    for (var i = 0; i < overlays.length; i++) {
      var track = overlays[i].querySelector('.pd-swipe__track');
      if (track) track.scrollLeft = 0;
      var picture = overlays[i].parentNode.querySelector('picture');
      if (picture) picture.style.transform = '';
    }
  }
  document.addEventListener('touchstart', onTouch, { capture: true, passive: true });
  document.addEventListener('pointerdown', onTouch, { capture: true, passive: true });
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  if (mq.addEventListener) {
    mq.addEventListener('change', function (ev) { if (!ev.matches) reset(); });
  }
  document.documentElement.classList.add('pd-swipe-ready');
})();
